import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'

const StyledCardContent = styled(CardContent)({
  padding: '1.5rem',
  ':last-child': { paddingBottom: '1.5rem' }
})

export default StyledCardContent;
